import { QuestelServicesClient, RequestResult, HttpMethodEnum } from '@questelservices/common';
import store from '../store';
import { ReportTypeEnum } from '@/models/ReportTypeEnum';
import { BrowseSelectionDataDto } from '@/models/browse-mode/BrowseSelectionDataDto';

export class ReportService {
    private client: QuestelServicesClient;

    constructor() {
      this.client = new QuestelServicesClient(store, '');
    }

    public async getReportOnDemand(batchId: Guid|null, agentIds: Guid[]|null, reportType: ReportTypeEnum): Promise<any> {
        return await this.client.getPostData(`/api/report/on-demand/${batchId}`, {agentIds : agentIds, reportType: reportType});
    }
    public async getReportOptions(clientId: Guid): Promise<BrowseSelectionDataDto[]> {
      return await this.client.get(`/api/Report/report-options/${clientId}`);
    }
}
